import { Download } from "lucide-react";

import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import { useIsDownloadsEnabled } from "@/services/featureFlags";

export const DownloadLoads = ({ filePath, className }) => {
    const canDownload = useIsDownloadsEnabled();
    return canDownload && filePath ? (
        <div className={cn("flex text-cm-p-accent text-sm items-center justify-center", className)}>
            <a
                href={`${import.meta.env.VITE_API_ROUTE}files/loads-csv/${filePath}`}
                download
                className="w-full h-full inline-flex items-center gap-2"
            >
                <Download className="w-4 h-4" />
                <TranslatedText text="Download loads" />
            </a>
        </div>
    ) : null;
};
